import { api_url } from "../../utils/constants";
const axios = require("axios").default;

export const registerUser = (
    emailId,
    password,
    userfname,
    userlname,
    accountType,
    countryName,
    countryCd,
    countryCurrCd,
    countryTelCd,
    location,
    latitude,
    longitude,
    captchaToken
) => {
    return new Promise((resolve, reject) => {
        const payload = {
            email: emailId,
            password,
            userfname,
            userlname,
            accountType,
            countryName,
            countryCd,
            countryCurrCd,
            countryTelCd,
            location: location ?? countryName,
            userLat: latitude,
            userLng: longitude,
            captchaToken,
        };

        axios({
            method: "POST",
            url: api_url + "/public/register",
            data: JSON.stringify(payload),
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            console.error(error);
            reject(error);
        });
    });
};
